import styles from './form.module.css';

const CustomCheckBox = ({labelFor, label, disabled = false, checked = false, onChange, textSize, className}) => {
  return (
    <div className={`space-x-2 flex items-center bg-hs ${styles.formCheck}${className ? ` ${className}` : ""}`}>
      <input
        className="appearance-none h-5 w-5 border border-gray-300 rounded bg-white checked:bg-secondary-500 disabled:bg-gray-300 disabled:border-gray-300 checked:border-secondary-600 focus:outline-none transition duration-200"
        type="checkbox" id={labelFor ?? label} disabled={disabled} checked={checked} onChange={onChange}/>
      {!!label &&
      <label className={`form-check-label inline-block text-gray-600 ${textSize ? textSize : 'text-base'}${disabled ? ' opacity-50' : ''}`}
             htmlFor={labelFor ?? label}>
        {label}
      </label>
      }

    </div>
  );
};

export default CustomCheckBox;
